function m(m){var i={};return m.multipleOf&&(i.step=m.multipleOf),(m.minimum||0===m.minimum)&&(i.min=m.minimum),(m.maximum||0===m.maximum)&&(i.max=m.maximum),i}export{m as default};
